import React, { useState } from 'react';

export const SideResult = ({res, readIslandData}) => {
  //console.log('SIDE RESULTE RES', res);
  const [color, setColor] = useState('white');
  return(
    <button
      onClick={() => readIslandData(res.HISTOLITT_V2)}
      onMouseOver={() => setColor('#dfdfdf')}
      onMouseOut={() => setColor('#fff')}
      className='search-result shadow flex-dir-column'
      id={'res' + res.HISTOLITT_V2}
      style={{ cursor: 'pointer', display: 'none', alignItems: 'flex-start', justifyContent: 'flex-start', borderWidth: 0,marginTop: 2, marginBottom: 2, padding: 4, backgroundColor: color, borderRadius: 5}}>
      <span style={{color: '#aaa', fontSize: 12, marginBottom: 3}}>{res.NOM_SHOM}</span>
      <span style={{fontSize: 20}}>{!!res.IGN ? res.IGN.charAt(0).toUpperCase() + res.IGN.slice(1).toLowerCase() : null}</span>
    </button>
  )
}